export default __webpack_public_path__ + "static/media/modal-icon-game-result-2GB.76a001fc.svg";